// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"107":"3e8713b5","333":"09a28e6a","677":"7b85324b"}[chunkId] + ".chunk.js";
};